import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { CircularProgress, Grid, Paper } from '@material-ui/core'
import axios from 'axios'
import { CustomFullPageWrapper, CustomPaperStyle } from './styles'
import CompanyLogo from '../app/components/companyLogo'
import { LoginTitle, StyledButton, StyledPosterCheckTextField } from '../theme/Global'
import LoginDialog from '../account/components/loginDialog'

const api = 'external/shipments/verify'
const headers = {}
headers['Content-Type'] = 'application/json'

const useQuery = () => {
  return new URLSearchParams(useLocation().search)
}

const PosterCheck = () => {
  const query = useQuery()
  const checkCode = query.get('scan')
  const [posterCheckCode, setPosterCheckCode] = useState(!checkCode ? '' : checkCode)
  const [status, setStatus] = useState('idle')
  const [errorMessage, setErrorMessage] = useState('')

  const onCheck = async () => {
    setStatus('attempting')
    const config = {
      baseURL: `${API_BASE_PATH}`,
      url: api,
      method: 'post',
      data: JSON.stringify({ posterCheckCode }),
      headers,
      responseType: 'json',
      validateStatus: () => true
    }

    const response = await axios(config)
      .catch((responseError) => {
        if (axios.isCancel(responseError)) {
          console.info('request canceled')
        } else {
          console.error(responseError)
        }
      })

    if (response.status >= 400) {
      setErrorMessage(response.data.error)
      return setStatus('failure')
    }
    return setStatus('success')
  }

  useEffect(() => {
    if (posterCheckCode) {
      onCheck()
    }
  }, [])

  const onCloseError = () => {
    setStatus('idle')
  }

  return (
    <CustomFullPageWrapper>
      <Grid
        container
        justify="center"
        style={{
          width: '100%',
          margin: 0
        }}
      >
        <Grid item xs={12} lg={12}>
          <Paper style={CustomPaperStyle}>
            <Grid container spacing={24}>
              <Grid item xs={12}>
                <CompanyLogo size="xlarge" color />
                <LoginDialog
                  loginError={errorMessage}
                  status={status}
                  onCloseError={onCloseError}
                />
              </Grid>
              {status === 'success'
                ? (
                  <Grid container spacing={24}>
                    <Grid item xs={12}>
                      <LoginTitle>Congratulations! Your poster is verified as displayed.</LoginTitle>
                    </Grid>
                    <Grid item xs={12}>
                      <StyledButton onClick={() => {
                        setStatus('idle')
                        setPosterCheckCode('')
                      }}
                      >
                        Back
                      </StyledButton>
                    </Grid>
                  </Grid>
                )
                : (
                  <Grid container spacing={24}>
                    <Grid item xs={12}>
                      <LoginTitle>Welcome to GovDocs PosterCheck</LoginTitle>
                    </Grid>
                    <Grid item xs={12}>
                      <StyledPosterCheckTextField
                        name="statusCode"
                        fullWidth
                        label="Enter the alphanumeric code printed on the PosterCheck sheet attached to your GovDocs labor law poster."
                        value={posterCheckCode}
                        onChange={(e) => setPosterCheckCode(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Grid
                        container
                        spacing={24}
                        direction="row"
                        justify="flex-start"
                        alignItems="center"
                      >
                        <Grid item>
                          <StyledButton
                            disabled={status === 'attempting'}
                            onClick={() => {
                              if (posterCheckCode) {
                                onCheck()
                              }
                            }}
                          >
                            {status === 'attempting' ? <CircularProgress size={16} style={{ marginRight: '10px' }} /> : null}
                            Submit
                          </StyledButton>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </CustomFullPageWrapper>
  )
}

export default PosterCheck
